<template>
  <q-layout view="lHh Lpr lFf" class="bg-grey-1">
    <!-- ГОРНА МЕНИ ЛЕНТА -->
    <q-header elevated class="bg-mint text-white">
      <q-toolbar class="justify-between q-px-md">
        <!-- Централен наслов -->
        <div class="header-user text-white text-subtitle1">
          <span class="text-bold">Внесување и преглед на барања за услуги</span>
        </div>

        <!-- Десна страна: Прегледи + Одјава -->
        <div class="flex items-center">
          <!-- Прегледи -->
          <q-btn
            flat
            dense
            round
            color="white"
            icon="analytics"
            class="review-icon q-mr-sm"
            @click="goToPregledi"
          >
            <q-tooltip>Прегледи</q-tooltip>
          </q-btn>

          <!-- Одјава -->
          <q-btn
            flat
            dense
            round
            color="white"
            icon="logout"
            class="logout-icon"
            @click="logout"
          >
            <q-tooltip>Одјави се</q-tooltip>
          </q-btn>
        </div>
      </q-toolbar>
    </q-header>

    <!-- СОДРЖИНА -->
    <q-page-container>
      <router-view />
    </q-page-container>
  </q-layout>
</template>

<script>
import { getUser } from "@/services/db";

export default {
  name: "ClientLayout",
  data() {
    return {
      firmaName: "",
      SESSION_MS: 120 * 60 * 1000,
      autoLogoutTimer: null,
    };
  },
  methods: {
    loadFirma() {
      const user = getUser();
      if (user && (user.firma || user.companyName)) {
        this.firmaName = user.firma || user.companyName;
      } else {
        this.firmaName = "Непозната фирма";
      }
    },

    logoutAuto() {
      localStorage.removeItem("user");
      if (this.autoLogoutTimer) clearTimeout(this.autoLogoutTimer);
      this.$router.replace("/najava-klient");
    },

    setupAutoLogout() {
      const raw = localStorage.getItem("user");
      if (!raw) return;

      let user = null;
      try {
        user = JSON.parse(raw);
      } catch (e) {
        return;
      }

      if (!user.loginAt) {
        user.loginAt = Date.now();
        localStorage.setItem("user", JSON.stringify(user));
      }

      const expiresAt = Number(user.loginAt) + this.SESSION_MS;
      const remaining = expiresAt - Date.now();

      if (remaining <= 0) {
        this.logoutAuto();
        return;
      }

      if (this.autoLogoutTimer) clearTimeout(this.autoLogoutTimer);

      this.autoLogoutTimer = setTimeout(() => {
        this.logoutAuto();
      }, remaining);
    },

    goToPregledi() {
      this.$router.push("/klient/pregledi");
    },

    logout() {
      localStorage.removeItem("user");
      if (this.autoLogoutTimer) clearTimeout(this.autoLogoutTimer);

      this.$router.replace("/najava-klient");
      this.$q.notify({
        color: "mint",
        message: "Успешно се одјавивте.",
        icon: "logout",
      });
    },
  },

  mounted() {
    this.loadFirma();
    this.setupAutoLogout();
  },

  beforeDestroy() {
    if (this.autoLogoutTimer) clearTimeout(this.autoLogoutTimer);
  },
};
</script>

<style scoped>
.bg-mint {
  background-color: #0e6b5f !important;
}
.text-white {
  color: white !important;
}

/* Фирма во хедер */
.header-user {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  font-weight: 500;
  letter-spacing: 0.3px;
}

/* Прегледи */
.review-icon {
  background-color: rgba(255, 255, 255, 0.12) !important;
  transition: all 0.25s ease;
}
.review-icon:hover {
  background-color: rgba(255, 255, 255, 0.25) !important;
  transform: translateY(-1px);
}

/* Одјава */
.logout-icon {
  background-color: rgba(255, 255, 255, 0.15) !important;
  transition: all 0.25s ease;
}
.logout-icon:hover {
  background-color: rgba(255, 255, 255, 0.3) !important;
  transform: translateY(-1px);
}
.logout-icon:active {
  transform: translateY(0);
  background-color: rgba(255, 255, 255, 0.25) !important;
}
</style>